import React, { useEffect, useState } from 'react';
import { useMagic } from '../../context/MagicContext';
import { Modal } from '../Modal';
import './HatchCinematic.css';
export const HatchCinematic: React.FC<{ onClose: () => void }> = ({ onClose }) => {
    const { processEvent } = useMagic();
    const [stage, setStage] = useState(() => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 3 : 0);
    useEffect(() => {
        if (stage === 3) return;
        const timer = setTimeout(() => setStage(n => n + 1), 1800);
        return () => clearTimeout(timer);
    }, [stage]);
    const acknowledge = () => { processEvent('hatch_cinematic_seen'); onClose(); };
    return <Modal title={stage === 3 ? 'Your dragon has arrived' : 'Something wonderful is stirring'} onClose={acknowledge} wide>
        <div className={'hatch-scene hatch-stage-' + stage}>
            <div className="hatch-aura" aria-hidden="true" />
            <img key={stage} src={'/ui/items/' + ['dragon_egg.png', 'egg_cracked.png', 'egg_glowing.png', 'dragon.png'][stage]}
                alt={['Your dragon egg', 'A crack in the shell', 'Golden light spilling from the egg', 'Your newborn dragon'][stage]} />
            <p role="status">{['Twenty treasures. One extraordinary secret.', 'A tiny heartbeat. A little crack.', 'All your little moments of magic brought us here.', 'Hello, little dreamer. Welcome to your world.'][stage]}</p>
            {stage < 3 ? <button className="action-secondary" onClick={() => setStage(3)}>Skip to the surprise</button>
                : <><p>You filled the shelves with curiosity, kindness and imagination. Keep making new memories together.</p><button className="action-primary" onClick={acknowledge}>Continue the adventure</button></>}
        </div>
    </Modal>;
};
